import { useEffect, useState } from "react";
import Lenis from "lenis";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import { About, Platform } from "@/components/site/AboutPlatform";
import Divisions from "@/components/site/Divisions";
import CurrentFocus from "@/components/site/CurrentFocus";
import { Capabilities, Methodology, AfricaEurope } from "@/components/site/Systems";
import { Journey, Partnership } from "@/components/site/Story";
import Projects from "@/components/site/Projects";
import { Resources, Connect, Contact, Footer } from "@/components/site/Closing";
import { api } from "@/lib/api";

export default function Home() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <main data-testid="home-page" className="bg-ink text-ivory overflow-x-clip">
      <Nav />
      <Hero settings={settings} />
      <Marquee />
      <About />
      <Platform />
      <Divisions />
      <CurrentFocus />
      <Capabilities />
      <Methodology />
      <AfricaEurope />
      <Journey />
      <Projects />
      <Partnership />
      <Resources />
      <Connect />
      <Contact settings={settings} />
      <Footer settings={settings} />
    </main>
  );
}
